import ExpertsServices from '../xx-vue/services/expert'
export default {
    namespaced: true,
    state: {
        page: 1,
        limit: 15,
        total: 0,
        newsClass: '',
        expertList: [
            { img_avatar_full: '' }
        ],//专家列表
        expertReview: [],//专家参与的评审
        newest: {},//最新专家
    },
    mutations: {
        getExpertList: (state, payload) => {
            state.expertList = payload
            console.log(state.expertList);
        },
        changePage: (state, payload) => {
            state.page = payload
        },
        changeLimit: (state, payload) => {
            state.limit = payload
        },
        changeClass: (state, payload) => {
            state.newsClass = payload
        },
        changeTotal: (state, payload) => {
            state.total = payload
        },
        changeReview: (state, payload) => {
            state.expertReview = payload
        },
        changeNewest: (state, payload) => {
            state.newest = payload
        },
    },
    actions: {
        getExpertList: async ({ commit, state, dispatch }) => {
            let data = { page: state.page, limit: state.limit };
            let result = await ExpertsServices.getExpertsAsync(data);
            commit('getExpertList', result.data.list);
            commit('changeTotal', result.data.total)
            commit('changeNewest', result.data.list[0])
        },
        getExpertByFirst: async ({ commit, state }, payload) => {
            let data = { page: state.page, limit: state.limit, first_py: payload };
            let result = await ExpertsServices.getExpertsAsync(data);
            commit('getExpertList', result.data.list);
            commit('changeTotal', result.data.total)
        },
    },
    getters: {
        pages: state => {
            return Math.ceil(state.total / state.limit);
        }
    }
}